import { Alert, ConfigProvider } from 'antd';
import axios from 'axios';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Close } from "asset/common/close_popup.svg";
import style from "css/myreservation.module.css";
import { useTranslation } from 'react-i18next';

function NoticeAlert() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [pageCount, setPageCount] = useState(0);
    const [notice, setNotice] = useState([]);
    const timerRef = useRef(null);

    const getNotice = useCallback(() => {
        axios.get("/notice/data/menu").then((res) => {
            if (res.status === 200) {
                setNotice(res.data);
            }
        });
    }, []);

    useLayoutEffect(() => {
        getNotice();
    }, [getNotice]);

    useEffect(() => {
        if (notice.length === 0) return;

        timerRef.current = setTimeout(() => {
            setPageCount((prevPage) =>
                prevPage === notice.length - 1 ? 0 : prevPage + 1
            );
        }, 10000);

        return () => {
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [notice.length, pageCount, timerRef]);

    const resetTimer = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    };

    const goToNext = () => {
        resetTimer();
        setPageCount((prevPage) =>
            prevPage === notice.length - 1 ? 0 : prevPage + 1
        );
    };

    const goToPrev = () => {
        resetTimer();
        setPageCount((prevPage) =>
            prevPage === 0 ? notice.length - 1 : prevPage - 1
        );
    };

    const onClose = () => {
        localStorage.setItem("noticeAlert", "false");
    }

    return (
        <ConfigProvider
            theme={{
                components: {
                    Alert: {
                        // colorInfo: "#000", // Text color
                        colorInfoBg: "#f4fcf9", // Background color
                        colorInfoBorder: "#1cb691", // Border color
                    },
                },
            }}
        >
            {notice.length > 0 &&
                <Alert
                    message={
                        <div className={style.notice_container}>
                            <div className={style.notice_content}>
                                <div className={style.notice_title}>{t("MENU.공지사항")}</div>
                                <div className={style.v_divider}></div>
                                <div
                                    className={`${style.notice_main} cursor`}
                                    onClick={() => navigate(process.env.REACT_APP_CLIENT_URL + "app/notice?ID=" + notice[pageCount]?.ID)}
                                >
                                    <div className={style.notice_date}>{notice[pageCount]?.date}</div>
                                    <div className={style.notice_text}>{notice[pageCount]?.content}</div>
                                </div>
                            </div>
                            <div className={style.notice_paging}>
                                {notice.length > 0 && (
                                    <>
                                        <img
                                            className={`${style.direction_left} cursor`}
                                            onClick={goToPrev}
                                            src={process.env.REACT_APP_CLIENT_URL + "img/menu/notice_left_black.png"}
                                            alt=""
                                        />
                                        <div className={style.paging_num}>
                                            {pageCount + 1} / {notice.length}
                                        </div>
                                        <img
                                            className={`${style.direction_right} cursor`}
                                            onClick={goToNext}
                                            // }}
                                            src={process.env.REACT_APP_CLIENT_URL + "img/menu/notice_right_black.png"}
                                            alt=""
                                        />
                                    </>
                                )}
                            </div>
                        </div>
                    }
                    type="info"
                    afterClose={onClose}
                    closeIcon={<Close />}
                    closable
                />
            }
        </ConfigProvider>
    )
}

export default NoticeAlert
